import { createSvgIcon } from './createSvgIcon'

export default createSvgIcon(
  <>
    <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4z"></path>
    <path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 10-2.5-1.5L15 12V4h5z"></path>
  </>,
  'CollectionsBookmark',
)
